







import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import CategoryCard from "./CategoryCard.vue";
import LandingContainer from "../LandingContainer";

export default defineComponent({
  name: "CategoriesBlock",
  components: { CategoryCard, LandingContainer },
  setup() {
    const cards = [
      {
        title: $t("Beauty"),
        img: {
          regular1x: "/img/landing/CategoriesBlock/beauty.png",
          regular2x: "/img/landing/CategoriesBlock/beauty@2x.png",
          webp1x: "/img/landing/CategoriesBlock/beauty.webp",
          webp2x: "/img/landing/CategoriesBlock/beauty@2x.webp",
        },
      },
      {
        title: $t("Fitness"),
        img: {
          regular1x: "/img/landing/CategoriesBlock/fitness.png",
          regular2x: "/img/landing/CategoriesBlock/fitness@2x.png",
          webp1x: "/img/landing/CategoriesBlock/fitness.webp",
          webp2x: "/img/landing/CategoriesBlock/fitness@2x.webp",
        },
      },
      {
        title: $t("Lifestyle"),
        img: {
          regular1x: "/img/landing/CategoriesBlock/lifestyle.png",
          regular2x: "/img/landing/CategoriesBlock/lifestyle@2x.png",
          webp1x: "/img/landing/CategoriesBlock/lifestyle.webp",
          webp2x: "/img/landing/CategoriesBlock/lifestyle@2x.webp",
        },
      },
    ];

    return {
      cards,
    };
  },
});
